import type { LayoutProviderProps } from "./_types";

import { memo } from "react";

import { Spin } from "antd";

import { Context } from "./_context";
import { useHooks } from "./_hook";

export default memo(({ children }: LayoutProviderProps) => {
  /** useHooks */
  const context = useHooks();

  /** return */
  return (
    <Context.Provider value={context}>
      <Spin size="large" spinning={context.loading}>
        {children}
      </Spin>
    </Context.Provider>
  );
});
